<template>
    <NuxtLoadingIndicator />
    <DynamicDialog />
    <FullPageLoader :show="impersonationLoader" />

    <ConfirmDialog group="confirmation" :pt="{ mask: { style: { background: 'rgba(0, 0, 0, 0.5)' } } }">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="delete-confirmation-container">
                <div>
                    <div
                        class="trash-icon-container"
                        :style="{
                            background: resolveIconBg(message.iconBg),
                            borderColor: resolveIconBorderColor(message.iconBorderColor)
                        }"
                    >
                        <component :is="message.icon" class="w-6 h-6" :style="{ color: message.iconColor }" />
                    </div>
                </div>

                <div class="w-full">
                    <h3 class="dialog-title">{{ message.header }}</h3>

                    <p class="dialog-text">
                        {{ message.message }}
                    </p>
                    <div class="flex items-center justify-end gap-3 mt-8">
                        <PrimeButton class="p-btn-root_secondary" :label="message.rejectLabel" @click="rejectCallback"></PrimeButton>
                        <PrimeButton
                            :label="message.acceptLabel"
                            @click="acceptCallback"
                            :loading="message.isLoading"
                        ></PrimeButton>
                    </div>
                </div>
            </div>
        </template>
    </ConfirmDialog>

    <div>
        <PersonSidebar />

        <div class="nuxt-page-view" :class="{ mobile: isMobile }">
            <div class="w-full">
                <NuxtPage />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import ConfirmDialog from 'primevue/confirmdialog';
import DynamicDialog from 'primevue/dynamicdialog';
import PersonSidebar from '~/components/layout/Person/PersonSidebar.vue';
import FullPageLoader from '~/components/shared/FullPageLoader.vue';
import { usePersonStore } from '~/stores/person';

// Utility functions for icon background and border color keywords
function resolveIconBg(type?: string) {
    if (type === 'success') return '#DCFAE6';
    if (type === 'reject') return '#FEE4E2';
    return type || 'var(--Error-100, #fee4e2)';
}

function resolveIconBorderColor(type?: string) {
    if (type === 'success') return '#ECFDF3';
    if (type === 'reject') return '#FEF3F2';
    return type || 'var(--Error-50, #fef3f2)';
}

const personStore = usePersonStore();
const { impersonationLoader } = storeToRefs(personStore);

const { isMobile } = useIsMobile();
</script>

<style lang="scss" scoped>
.nuxt-page-view {
    @apply bg-zinc-50;
    margin-left: 280px;
    transition: margin-left 0.3s ease-in-out;

    &.mobile {
        margin-left: 0;
    }

    @media screen and (max-width: 1023.98px) {
        margin-left: 0;
    }
}

.delete-confirmation-container {
    @apply sm:max-w-lg sm:w-[544px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto p-6 gap-4 flex;

    .trash-icon-container {
        @apply border border-8 rounded-3xl;
    }

    .close-button {
        @apply p-2 hover:bg-white rounded-full transition-colors;
    }

    .dialog-text {
        @apply text-sm font-normal font-inter text-gray-600;
    }

    .dialog-title {
        @apply text-lg font-semibold font-inter text-gray-900 mb-2;
    }
}
</style>
